var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTulu4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2064",
    transform: "translate(127 1220)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h75v75H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Live data dashboard",
    transform: "translate(-127 -1220)",
    style: {
      clipPath: "url(#a)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4218",
    d: "M181.458 1277.086h-34.886a5.6 5.6 0 0 1-5.6-5.595v-22.656a5.6 5.6 0 0 1 5.6-5.595h34.884a5.6 5.6 0 0 1 5.6 5.595v22.656a5.6 5.6 0 0 1-5.598 5.595zm-34.884-32.2a3.956 3.956 0 0 0-3.951 3.951v22.656a3.956 3.956 0 0 0 3.951 3.952h34.884a3.956 3.956 0 0 0 3.951-3.952v-22.656a3.956 3.956 0 0 0-3.951-3.951z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4219",
    d: "M187.992 1293.974h-47.953a1.977 1.977 0 0 1-1.977-1.977 4.271 4.271 0 0 1 4.271-4.271h43.366a4.271 4.271 0 0 1 4.271 4.271 1.977 1.977 0 0 1-1.978 1.977z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4220",
    d: "M186.985 1240.356h-45.938a4.051 4.051 0 0 0-4.047 4.047v31.519a4.052 4.052 0 0 0 4.047 4.047h19.6v1.959h-2.854a1.737 1.737 0 0 0-1.737 1.737v.866a1.737 1.737 0 0 0 1.737 1.737h12.437a1.737 1.737 0 0 0 1.737-1.737v-.866a1.737 1.737 0 0 0-1.737-1.737h-2.854v-1.959h19.6a4.052 4.052 0 0 0 4.047-4.047v-31.519a4.051 4.051 0 0 0-4.038-4.047zm2.4 35.566a2.406 2.406 0 0 1-2.4 2.4h-45.938a2.406 2.406 0 0 1-2.4-2.4v-31.519a2.406 2.406 0 0 1 2.4-2.4h45.938a2.406 2.406 0 0 1 2.4 2.4z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4221",
    d: "m161.564 1271.052-5.322-14.191-7.717 7.944-1.188-1.154 9.539-9.819 5.336 14.23 15.331-15.332 1.171 1.171z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4222",
    d: "m177.713 1258.36-1.538-.615 1.525-3.811-4.121 1.433-.544-1.565 7.552-2.627z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTulu4);
export default __webpack_public_path__ + "static/media/myTulu4.d847390c0fb0bcc87e67a48d1c63a510.svg";
export { ForwardRef as ReactComponent };